// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface StorageTotals
 */
export interface StorageTotals {
  /**
   *
   */
  projectFiles: number;
  /**
   *
   */
  projectSchematisations: number;
  /**
   *
   */
  catalogueSchematisations: number;
  /**
   *
   */
  total: number;
}

/**
 * Check if a given object implements the StorageTotals interface.
 */
export function instanceOfStorageTotals(value: object): value is StorageTotals {
  if (
    (!("projectFiles" in (value as Record<string, any>)) &&
      !("project_files" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["projectFiles"] === undefined &&
      (value as Record<string, any>)["project_files"] === undefined)
  )
    return false;
  if (
    (!("projectSchematisations" in (value as Record<string, any>)) &&
      !("project_schematisations" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["projectSchematisations"] === undefined &&
      (value as Record<string, any>)["project_schematisations"] === undefined)
  )
    return false;
  if (
    (!("catalogueSchematisations" in (value as Record<string, any>)) &&
      !("catalogue_schematisations" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["catalogueSchematisations"] === undefined &&
      (value as Record<string, any>)["catalogue_schematisations"] === undefined)
  )
    return false;
  if (!("total" in value) || value["total"] === undefined) return false;
  return true;
}

export function StorageTotalsFromJSON(json: any): StorageTotals {
  return StorageTotalsFromJSONTyped(json, false);
}

export function StorageTotalsFromJSONTyped(json: any, ignoreDiscriminator: boolean): StorageTotals {
  if (json == null) {
    return json;
  }
  return {
    projectFiles: json["project_files"],
    projectSchematisations: json["project_schematisations"],
    catalogueSchematisations: json["catalogue_schematisations"],
    total: json["total"],
  };
}

export function StorageTotalsToJSON(json: any): StorageTotals {
  return StorageTotalsToJSONTyped(json, false);
}

export function StorageTotalsToJSONTyped(
  value?: StorageTotals | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    project_files: value["projectFiles"],
    project_schematisations: value["projectSchematisations"],
    catalogue_schematisations: value["catalogueSchematisations"],
    total: value["total"],
  };
}
